/**
 * PUWYLO Homepage Expansion — feature killswitch helpers.
 *
 * Single source of truth for the initiative's killswitches, read off the global
 * UFE config (SSR-safe — populated on both server and client):
 *  - `digitalPuwyloHomepageExpansion` — the feature killswitch (gates all FE behavior).
 *  - `digitalPuwyloHomepageBatchApi` — a PROVISIONAL backend-readiness gate for the
 *    batch API call only.
 */

const KILLSWITCH_NAME = 'digitalPuwyloHomepageExpansion';
const BATCH_API_KILLSWITCH_NAME = 'digitalPuwyloHomepageBatchApi';

function isPuwyloHomepageExpansionEnabled() {
    return Sephora?.configurationSettings?.[KILLSWITCH_NAME]?.isEnabled === true;
}

// PROVISIONAL: gates only the batch API network call while the backend is in-flight.
function isPuwyloBatchApiEnabled() {
    return Sephora?.configurationSettings?.[BATCH_API_KILLSWITCH_NAME]?.isEnabled === true;
}

/**
 * Selects the PUWYLO batch cards eligible to display in the carousel: excludes cards
 * with no products (no empty slots) while preserving the order received from the batch
 * API. The backend returns cards in the Contentful-configured order (BR-020), so the
 * frontend renders them as-received and does NOT re-sort. Pure + SSR-safe; never
 * mutates the input array.
 *
 * @param {Array} cards normalized batch cards ({ contextId, displayOrder, products, ... })
 * @returns {Array} filtered copy in received order
 */
function getEligiblePuwyloCards(cards) {
    if (!Array.isArray(cards)) {
        return [];
    }

    return cards.filter(card => Array.isArray(card?.products) && card.products.length > 0);
}

/**
 * Decides whether the enhanced PUWYLO carousel should render. True only when the
 * killswitch is on AND `batchData` is non-null AND at least one card survives
 * the empty-product filter. Otherwise false → existing carousel / fallback path.
 *
 * @param {Object|null} batchData normalized batch payload or null fallback sentinel
 * @returns {boolean}
 */
function shouldUsePuwyloCarousel(batchData) {
    if (!isPuwyloHomepageExpansionEnabled() || !batchData) {
        return false;
    }

    return getEligiblePuwyloCards(batchData.cards).length > 0;
}

export default { isPuwyloHomepageExpansionEnabled, isPuwyloBatchApiEnabled, getEligiblePuwyloCards, shouldUsePuwyloCarousel };
